import { render, staticRenderFns } from "./PremiumLawyerOfficeProfile.vue?vue&type=template&id=62aa2a8c"
import script from "./PremiumLawyerOfficeProfile.vue?vue&type=script&lang=js"
export * from "./PremiumLawyerOfficeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports